import { InjectionToken } from '@angular/core';

export const PORTAL_TELEHEALTH_ACTION_BAR_COMPONENT = new InjectionToken(
  'PortalTelehealthActionBarComponent'
);
